export const GROUP_DETAILS_MODAL_TAB = {
    SpotsBooked: 'SpotsBooked',
    Waitlist: 'Waitlist',
};
